import React, {useEffect, useState} from 'react';
import {Button, Skeleton, Space} from 'antd';
import {useTranslation} from 'react-i18next';
import {useFacets} from '../../contexts/AggsContext';

export function FacetError({retry}) {
    const {t} = useTranslation();
    return <Space role="status">
        {t('facet-counts-failed', 'Could not load counts.')}
        <Button size="small" onClick={retry}>{t('retry', 'Retry')}</Button>
    </Space>;
}

export default function DeferredFacets({fields = [], children}) {
    const {t} = useTranslation();
    const {available, failed, retry} = useFacets(fields);
    const [mounted, setMounted] = useState(false);
    useEffect(() => { if(available) setMounted(true); }, [available]);
    // Keep controls visible during same-search refreshes; a new search clears
    // availability, hiding obsolete counts while preserving local control state.
    return <>
        {failed ? <FacetError retry={retry}/> : !available &&
            <div role="status" aria-label={t('loading-counts', 'Loading counts')}><Skeleton active paragraph={{rows: 2}} title={false}/></div>}
        <div hidden={!available}>{(mounted || available) && children}</div>
    </>;
}
